import get from "lodash.get";

import AuthenticationActionTypes from "services/authentication/types";
import ContractActionTypes from "services/contract/types";
import INITIAL_STATE from "./abstractInitialState";

/* eslint-disable class-methods-use-this */
class AbstractApiReducer {
  initialState = INITIAL_STATE;

  constructor(actionTypes = {}, initialState = {}, mapActionToMethods = {}) {
    this.initialState = {
      ...this.initialState,
      ...initialState,
      list: {
        ...this.initialState.list,
        ...initialState.list,
      },
    };

    this.mapActionToMethods = {
      [ContractActionTypes.SWITCH_CONTRACT]: this.resetStore.bind(this),
      [AuthenticationActionTypes.LOG_OUT]: this.resetStore.bind(this),
      [actionTypes.SET_INITIALIZED]: this.setInitializedAction,
      [actionTypes.SET_FILTERS]: this.setFilters,
      [actionTypes.SET_FILTER]: this.setFilter,
      [actionTypes.SET_LIST_HOVER_INDEX]: this.setListHoverIndexAction,
      [actionTypes.SET_LIST_ORDERS]: this.setListOrdersAction,
      [actionTypes.SET_LIST]: this.setListAction,
      [actionTypes.SET_LIST_SELECTED_INDEX]: this.setListSelectedIndexAction,
      ...mapActionToMethods,
    };
  }

  resetStore(state, action) {
    return this.initialState;
  }

  setInitializedAction(state, action) {
    return {
      ...state,
      [action.store]: {
        ...get(state, `[${action.store}]`),
        initialized: action.value,
      },
    };
  }

  setFilters(state, action) {
    return {
      ...state,
      filters: action.value,
    };
  }

  setFilter(state, action) {
    return {
      ...state,
      filters: {
        ...state.filters,
        [action.key]: action.value,
      },
    };
  }

  setListHoverIndexAction(state, action) {
    return {
      ...state,
      list: {
        ...state.list,
        hoverIndex: action.value,
      },
    };
  }

  setListSelectedIndexAction(state, action) {
    return {
      ...state,
      list: {
        ...state.list,
        selectedIndex: action.value,
      },
    };
  }

  setListOrdersAction(state, action) {
    return {
      ...state,
      list: {
        ...state.list,
        orders: { ...state.list.orders, ...action.value },
      },
    };
  }

  setListAction(state, action) {
    const items = get(action, "value.items", []);

    return {
      ...state,
      list: {
        ...state.list,
        selectedIndex: null,
        hoverIndex: null,
        page: 0,
        initialized: true,
        items,
        length: get(items, "length", 0),
        others: get(action, "value.others", null),
      },
    };
  }

  reducer = (state = this.initialState, action) => {
    if (this.mapActionToMethods[action.type] !== undefined) {
      return this.mapActionToMethods[action.type](state, action);
    }

    return state;
  };
}

export default AbstractApiReducer;
